import React, { useState, useCallback, useEffect } from 'react'
import LayoutWithOutAccountCard from '../../Layout/layout-without-card'
import QuickLinkService from '../../../services/quick-link.service'
import Loading from 'custom/assets/loaders/Loading'
import NeoButton from '../../../components/NeoButton/NeoButton'
import NeoInput from '../../../components/NeoInput/NeoInput'
import InputError from '../../../components/InputError/InputError'
import * as Yup from 'yup'
import { Formik, Form } from 'formik'
import moment from 'moment'
import '../../../index.css'
import CustomPagination from '../../../components/pagination'
import {ReceiptSchema} from "../../../schemas/downloadCenter"
import { BUTTON_KEYS, VALIDATION_KEYS, DOWNLOAD_RECEIPT_KEYS  } from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next';
import validationConfig from 'custom/config/validation.config.json'
const receiptConfig = validationConfig['downloadCenter']['receipt']

export default function Receipts() {
  const [receiptsDetails, setReceiptsDetails] = useState()
  const [loading, setLoading] = useState(false)
  const [loadingState, setLoadingState] = useState(false)
  const [stage, setStage] = useState(0)
  const [expanded, setExpanded] = useState(null)
  const [noRecords, setNoRecords] = useState(false)
  const [minValue, setMinValue] = useState(0)
  const [maxValue, setMaxValue] = useState(10)
  const {t}=useTranslation()

  // const handleChange = useCallback((value) => {
  //   setExpanded(null)
  //   setMinValue((value - 1) * 10)
  //   setMaxValue(value * 10)
  // }, [])

  const getReciept = useCallback(async (values) => {
    try {
      setLoading(true)
      setStage(0)
      const response = await QuickLinkService.getReciept(values)
      if (response.status === 200) {
        setNoRecords(response.data['userReceiptRecord'].length > 0 ? false : true)
        setReceiptsDetails(response.data['userReceiptRecord'])
        setStage(1)
        setLoading(false)
      }
    } catch (err) {
      console.error(err)
      //setStage(1)
      setLoading(false)
    }
  }, [])

  const pdfReceipt = useCallback(async (values) => {
    try {
      setLoadingState(true)
      const reqParams = {
        ...values,
        batchId: values.batchId,
        transRefNum: values.transRefNum,
        refId: values.receiptId,
      }
      await QuickLinkService.pdfReceipt(reqParams)
      setLoadingState(false)
    } catch (err) {
      setLoadingState(false)
      console.error(err)
    }
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderReceiptsViewForm()
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderReceiptsViewForm() {
    return (
      <div>
        <Formik
          initialValues={{
            fromDate: '',
            toDate: '',
          }}
          onSubmit={getReciept}
          validationSchema={ReceiptSchema}>
          {({ isSubmitting, errors, touched, handleChange }) => (
            <Form>
              <div className='row form-inline ml-3'>
                <div className=' mr-3'>
                  <NeoInput
                    showAsterisk={receiptConfig['isFromDateRequired']}
                    text={t(DOWNLOAD_RECEIPT_KEYS.FROM_DATE)}
                    name='fromDate'
                    type='date'
                    disabled={loading}
                    onChange={handleChange}
                    max={moment(new Date()).format('YYYY-MM-DD')}
                  />
                  <InputError text={errors.fromDate} touched={touched.fromDate} />
                </div>
                <div className=' mr-3'>
                  <NeoInput
                    showAsterisk={receiptConfig['isToDateRequired']}
                    text={t(DOWNLOAD_RECEIPT_KEYS.TO_DATE)}
                    name='toDate'
                    type='date'
                    disabled={loading}
                    onChange={handleChange}
                    max={moment(new Date()).format('YYYY-MM-DD')}
                  />
                  <InputError text={errors.toDate} touched={touched.toDate} />
                </div>
                <div className='form-group mt-3  '>
                  {loading ? (
                    renderLoading()
                  ) : (
                    <NeoButton disabled={loading} type='submit' text={t(BUTTON_KEYS.SEARCH)} mode='newDesign' />
                  )}
                </div>
              </div>
            </Form>
          )}
        </Formik>

        {receiptsDetails !== null && receiptsDetails !== undefined && (
          <>
            {loadingState ? renderLoading() : null}
            <div style={{ justifyContent: ' space-between', alignItems: 'center' }}>
              <div>
                <div className='loan-header mt-3 mb-3'>
                  <div className='headingCell5'>{t(DOWNLOAD_RECEIPT_KEYS.RECEIPT_ID)}</div>
                  <div className='headingCell5'>{t(DOWNLOAD_RECEIPT_KEYS.TRANSFER_TYPE)}</div>
                  <div className='headingCell5'>{t(DOWNLOAD_RECEIPT_KEYS.TRANSATION_TIME)}</div>
                  <div className='headingCell5'>{t(DOWNLOAD_RECEIPT_KEYS.ACTION)}</div>
                </div>
                {/* {noRecords && (
                  <div className='no-data-found'>You don't have any Loan account till now </div>
                )} */}
                {receiptsDetails.length > 0 ? (
                  receiptsDetails.slice(minValue, maxValue).map((item, index) => (
                    <>
                      <div
                        className=' loan-card'
                        onClick={() =>
                          expanded === index ? setExpanded(null) : setExpanded(index)
                        }
                        key={index}>
                        <div className='loan-header'>
                          <div className='d-flex align-items-center justify-space-between'>
                            {item.receiptId}
                          </div>
                          <div className='d-flex align-items-center justify-space-between'>
                            {item.transferType}
                          </div>
                          <div className='d-flex align-items-center justify-space-between'>
                            {moment(item.transTime).format('DD-MM-YYYY')}
                          </div>
                          <div className='d-flex align-items-center justify-space-between'>
                            <button
                              type='button'
                              className='btn btn-link new-design-warning-text-color font-weight-600 download'
                              onClick={() => pdfReceipt(item)}>
                             {t(BUTTON_KEYS.DOWNLOAD)}
                            </button>
                          </div>
                        </div>
                        {expanded === index && (
                          <div className='loan-details '>
                            <div className='row beneficiary-details  justify-space-between '>
                              <div className='col-10'>
                                <div className='row'>
                                  <div className='col-4'>
                                    <div className='label'>{t(DOWNLOAD_RECEIPT_KEYS.RECEIPT_ID)}</div>
                                    <div className='value'>{item?.receiptId || '-'}</div>
                                  </div>
                                  <div className='col-4'>
                                    <div className='label'>{t(DOWNLOAD_RECEIPT_KEYS.TRANSACTION_REF_NO)}</div>
                                    <div className='value'>{item?.transRefId || '-'}</div>
                                  </div>
                                  <div className='col-4'>
                                    <div className='label'>{t(DOWNLOAD_RECEIPT_KEYS.TRANSACTION_DATE)}</div>
                                    <div className='value'>
                                    {moment(item.transTime).format('DD-MM-YYYY')}
                                    </div>
                                  </div>
                                </div>

                                <div className='row'>
                                  <div className='col-4'>
                                    <div className='label'>{t(DOWNLOAD_RECEIPT_KEYS.TRANSFER_TYPE)}</div>
                                    <div className='value'>{item?.transferType || '-'}</div>
                                  </div>
                                  <div className='col-4'>
                                    <div className='label'>{t(DOWNLOAD_RECEIPT_KEYS.REQUESTS_DESCRIPTION)}</div>
                                    <div className='value'>{item?.requestDesc || '-'}</div>
                                  </div>
                                  <div className='col-4'>
                                    <div className='label'>{t(DOWNLOAD_RECEIPT_KEYS.SOURCE_ACCOUNT)}</div>
                                    <div className='value'>{item?.srcAcc || '-'}</div>
                                  </div>
                                </div>

                                <div className='row'>
                                  <div className='col-4'>
                                    <div className='label'>{t(DOWNLOAD_RECEIPT_KEYS.DESTINATION_ACCOUNT)}</div>
                                    <div className='value'>{item?.destAcc || '-'}</div>
                                  </div>
                                  <div className='col-4'>
                                    <div className='label'>{t(DOWNLOAD_RECEIPT_KEYS.AMOUNT)}</div>
                                    <div className='value'>{item?.amount || '-'}</div>
                                  </div>
                                  <div className='col-4'>
                                    <div className='label'>{t(DOWNLOAD_RECEIPT_KEYS.USERNAME)}</div>
                                    <div className='value'>{item?.userId || '-'}</div>
                                  </div>
                                  <div className='col-4'>
                                    <div className='label'>{t(DOWNLOAD_RECEIPT_KEYS.REMARKS)}</div>
                                    <div className='value'>{item?.remarks || '-'}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  ))
                ) : (
                  <p style={{ textAlign: 'center', marginTop: 20 }}>{t(DOWNLOAD_RECEIPT_KEYS.NO_RECORDS_FOUND)}</p>
                )}
              </div>

              <div>
                {receiptsDetails.length > 10 && <CustomPagination
                  defaultPageSize={10}
                  setMaxValue={(value) => {
                    setExpanded(null)
                    setMaxValue(value)
                  }}
                  setMinValue={(value) => setMinValue(value)}
                  totalLength={receiptsDetails.length}
                  defaultCurrent={1}
                />}
              </div>
            </div>
          </>
        )}
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='BENE_RECIEPT' showEmptySpace={true} keyPath={'RECEIPTS'}>
      <div className='heading-style'>{t(DOWNLOAD_RECEIPT_KEYS.TITLE)}</div>
      {renderReceiptsViewForm()}
    </LayoutWithOutAccountCard>
  )
}
